import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './App.tsx'
import { applyDocumentLocale } from './utils/locale'
// Initialize optional web telemetry in development when endpoint is provided
if (import.meta.env.DEV && import.meta.env.VITE_OTEL_EXPORTER_URL) {
  import('./otel-web').catch(() => {/* ignore otel init errors in dev */});
}

applyDocumentLocale();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
